"use client";

import { useFormStatus } from "react-dom";
import { Button } from "@mui/material";

interface SubmitButtonProps {
  label?: string;
  pendingLabel?: string;
}

export default function SubmitButton({
  label = "Submit",
  pendingLabel,
}: SubmitButtonProps) {
  const { pending } = useFormStatus();
  const displayLabel = pending ? pendingLabel || `${label}ing...` : label;

  return (
    <Button type="submit" color="primary" variant="outlined" disabled={pending}>
      {displayLabel}
    </Button>
  );
}
